import { requestWithPromise } from '..'
import { DELETE } from '../apiHelper'

export const deleteAct = (act, user) => {
  return requestWithPromise('/api/Act/' + act.id, DELETE, null, user)
}
